<div class="agpr-formField agpr-briefingSortByField">
    <div class="agpr-briefingSortByField-sortByDropdown">
        @if (field.allowAutomaticallyGenerate && block?.displayElement?.automaticallyGenerated) {
            <agpr-text-input
                [placeholder]="'PageBuilder.automaticallyGeneratedContent.placeholder' | localize"
                [disabled]="true"
                [label]="field.label"
            ></agpr-text-input>
        } @else {
            <agpr-dropdown
                [options]="sortOptions | localizeList: []:'label'"
                [(ngModel)]="sortByDropdown"
                (ngModelChange)="onSortByChanged($event.value)"
                [label]="field.label"
            ></agpr-dropdown>
        }
    </div>
</div>
